import "./ticket.css";
import {homeHippodrome, tipstersData, todayResults} from "../../../store/misc.store";
import {getBulletin, getBulletinCardId, useBulletin} from "features/bulletin/bulletin.store";
import {BettingTypesMap} from "features/core/definitions";
import {useNavigate} from "react-router-dom";
import paths from "../../../paths";
import {buildMutualBettingSubTypes, buildMutualBettingTypes} from "features/bulletin/bulletin.service";
import {restoreMutualCoupon, showMutualReplayError} from "features/betslip/mutual.service";
import {modalServiceSubject} from "../../../services/modal.service";
import React from "react";

function showClosedTicketModal() {
    modalServiceSubject.next({
        title: "Kapanmış Bahis",
        content:
            '<div class="text-center"><p>Bu kupon artık oynanabilir değil. Farklı bir kupon yapabilir yada yorumcularımzın diğer kuponlarını oynayabilirsiniz.</p></div>',
        confirm: {
            cancel: {
                label: "Tamam",
            },
        },
    });
}

function playMutualTicket(ticket: any, selectedHippodrome: any, navigate: (path: string) => void) {
    const cardHippodrome = getBulletin()[selectedHippodrome._id] ?? selectedHippodrome;
    const betType = cardHippodrome?.wager_details?.find(
        (w: any) => Number(w.type) === Number(ticket.bet_type)
    );

    if (!betType || !betType.runs.includes(ticket.race_id)) {
        showClosedTicketModal();
        return;
    }

    try {
        restoreMutualCoupon(cardHippodrome, ticket);
    } catch (error: any) {
        showMutualReplayError(error?.message ?? "Kupon yüklenemedi.");
        return;
    }

    navigate(`${paths.betting.url}/${selectedHippodrome.keyword.toLowerCase()}${selectedHippodrome._id}`);
}

function playMutualRapidTicket(
    ticket: any,
    selectedHippodrome: any,
    type: any,
    subType: any,
    navigate: (path: string) => void
) {
    const cardHippodrome = getBulletinCardId()[Number(ticket.card_id)] ?? selectedHippodrome;
    const betType = cardHippodrome?.wager_details?.find((w: any) => Number(w.type) === Number(type));

    if (!betType) {
        showClosedTicketModal();
        return;
    }

    try {
        const legs = String(subType.label).split("-").map((runNo: any) => {
            const leg = ticket.legs?.[Number(runNo) - Number(ticket.race_id)];
            if (!leg) {
                throw new Error(`${runNo}. koşu bu kuponda yer almıyor.`);
            }
            return leg;
        });
        restoreMutualCoupon(cardHippodrome, {
            bet_type: type,
            race_id: subType.id,
            legs: legs,
            multiply: ticket.multiply,
        });
    } catch (error: any) {
        showMutualReplayError(error?.message ?? "Kupon yüklenemedi.");
        return;
    }

    navigate(`${paths.betting.url}/${selectedHippodrome.keyword.toLowerCase()}${selectedHippodrome._id}`);
}

function TicketHeader({ticket, selectedHippodrome, showSixOrdinal}: any) {
    const bettingType = BettingTypesMap[Number(ticket.bet_type)];
    const tipster = tipstersData[ticket.member_id];
    return (
        <div className="header d-flex align-items-center justify-content-between">
            <div className={"d-flex"}>
                <img
                    className="avatar"
                    src={tipster?.avatar || "/assets/tipster/default_avatar_tipster_at_yarisi.png"}
                    alt=""
                />
                <div className={"d-flex flex-column"}>
                    <h3>{tipster?.nick_name ?? `${tipster?.first_name} ${tipster?.last_name}`}</h3>
                    <span className={"bet-info"}>{selectedHippodrome.hippodrome}</span>
                </div>
            </div>

            <div className={"d-flex flex-column align-items-end"}>
                <span className="bet-info">
                    {showSixOrdinal && bettingType?.name === "6'lı Ganyan" && `${ticket.race_id > 1 ? "2." : "1."} `}
                    {bettingType?.shortName ?? bettingType?.name}
                </span>
                {bettingType.columnLabel === "At" && <span className="bet-info">{ticket.race_id}. Koşu</span>}
            </div>
        </div>
    );
}

function RapidCouponMenu({types, onPick}: any) {
    return (
        <ul className="dropdown-menu rapid-menu bg-white">
            {types.map((type: any, key: number) => (
                <li key={`rapid-${key}`}>
                    <a className="dropdown-item text-start" href="#" onClick={() => onPick(type)}>
                        {type.betType.name} ({type.label})
                    </a>
                </li>
            ))}
        </ul>
    );
}

export function Ticket(props: any) {
    const navigate = useNavigate();
    const bulletin = useBulletin();

    let selectedHippodrome = props.hippodrome !== undefined ? props.hippodrome : homeHippodrome;
    let ticket = props.ticket;

    let playableTicketTypes = [];
    let availableTypes = buildMutualBettingTypes(selectedHippodrome);
    let myRuns: any = [];


    for (let i = 0; i < BettingTypesMap[ticket.bet_type].column; i++) {
        myRuns.push(i + Number(ticket.race_id));
    }
    for (const availableType of availableTypes) {
        if (!BettingTypesMap[availableType.id]?.isFob) {
            let availableSubTypes = buildMutualBettingSubTypes(availableType);
            for (const availableSubType of availableSubTypes) {
                if (myRuns.join(",").includes(availableSubType.label.split('-').join(","))) {
                    if (availableType.columnLabel !== 'At') {
                        availableSubType.betType = availableType;
                        playableTicketTypes.push(availableSubType);
                    }
                }
            }
        }

        // for (const betTypeRun of availableType.runs) {
        //     playableRuns = [];
        //     for (let i = 0; i < availableType.column; i++) {
        //         playableRuns.push(betTypeRun + i);
        //     }
        //     playableRunsMap[betTypeRun] = playableRuns;
        // }
    }


    const playTicket = (ticket: any) => {
        playMutualTicket(ticket, selectedHippodrome, navigate);
    };

    const playRapid = async (ticket: any, type: any, subType: any) => {
        playMutualRapidTicket(ticket, selectedHippodrome, type, subType, navigate);
    };
    return (
        <>
            <div className="ticket-widget" key={ticket.id}>
                <TicketHeader ticket={ticket} selectedHippodrome={selectedHippodrome} showSixOrdinal={false}/>
                <div className="body">
                    <div className={"legs"}>
                        {ticket.legs.map((run: any, legIndex: number) => {

                            return <div
                                className={`run ${
                                    bulletin[selectedHippodrome._id]?.runsMap[ticket.race_id + legIndex]?.status === 0 ? "" : "disabled"
                                }`}
                                key={`legIndex-${legIndex}`}
                            >
                                <div>
                                    {BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At"
                                        ? ticket.race_id + legIndex
                                        : legIndex + 1}
                                    .{ticket.legs.length > 4 && <br/>}
                                    {/*{ticket.bet_type === 18 ? 'Koşu' : BettingTypesMap[Number(ticket.bet_type)].columnLabel}*/}
                                </div>
                                {run.map((horse: any, horseIndex: number) => {
                                    let isWinner = false;
                                    try {
                                        isWinner = todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerHorse.no.toString() === horse.toString()
                                        if (BettingTypesMap[Number(ticket.bet_type)]?.isStablemateWins && !isWinner){
                                            if (todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate){
                                                for (const horseElement of todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate) {
                                                    isWinner = horseElement.no.toString() === horse.toString()
                                                }
                                            }

                                        }

                                    }catch (e) {
                                        console.error(e);
                                    }

                                    return <div className={`${isWinner ? 'text-danger fw-bold' : ''}`} key={`horseIndex-${horseIndex}`}>{horse}</div>
                                })}
                            </div>
                        })}

                    </div>
                    {playableTicketTypes.length > 0 && <div className={"row "}>
                        <div className={"col-12"}>
                            <div className="dropdown">
                                <button
                                    className={`btn btn-sm btn-six dropdown-toggle mt-3 w-100 fw-bold`}
                                    data-bs-toggle="dropdown"
                                    style={{color: "#FFFFFF"}}
                                    aria-expanded="false"
                                >
                                    Hızlı Kupon
                                </button>
                                <RapidCouponMenu types={playableTicketTypes} onPick={(type: any) => playRapid(ticket, type.betType.id, type)}/>
                            </div>
                        </div>


                    </div>}


                </div>
                <div className="footer">

                    <div className="info">
            <span>
              BAHİS: <b>{ticket.bet_count}</b> MİSLİ: <b>{ticket.multiply}</b>
            </span>
                        <span>
              TUTAR: <b>{ticket.amount}₺</b>
            </span>
                    </div>
                    <div
                        className={`status cursor-pointer`}
                        onClick={() => {
                            playTicket(ticket);
                        }}
                    >
                        OYNA
                    </div>
                </div>
            </div>
        </>
    );
}

export function MobileTicket(props: any) {
    const navigate = useNavigate();
    const bulletin = useBulletin();
    let selectedHippodrome = props.hippodrome !== undefined ? props.hippodrome : homeHippodrome;
    let ticket = props.ticket;

    let playableTicketTypes = [];
    let availableTypes = buildMutualBettingTypes(selectedHippodrome);
    let myRuns: any = [];


    for (let i = 0; i < BettingTypesMap[ticket.bet_type].column; i++) {
        myRuns.push(i + Number(ticket.race_id));
    }
    for (const availableType of availableTypes) {
        let availableSubTypes = buildMutualBettingSubTypes(availableType);
        for (const availableSubType of availableSubTypes) {
            if (myRuns.join(",").includes(availableSubType.label.split('-').join(","))) {
                if (availableType.columnLabel !== 'At') {
                    availableSubType.betType = availableType;
                    playableTicketTypes.push(availableSubType);
                }
            }
        }
        // for (const betTypeRun of availableType.runs) {
        //     playableRuns = [];
        //     for (let i = 0; i < availableType.column; i++) {
        //         playableRuns.push(betTypeRun + i);
        //     }
        //     playableRunsMap[betTypeRun] = playableRuns;
        // }
    }

    const playTicket = (ticket: any) => {
        playMutualTicket(ticket, selectedHippodrome, navigate);
    };

    const playRapid = async (ticket: any, type: any, subType: any) => {
        playMutualRapidTicket(ticket, selectedHippodrome, type, subType, navigate);
    };

    return (
        <>
            <div className="ticket-widget" key={ticket.id}>
                <TicketHeader ticket={ticket} selectedHippodrome={selectedHippodrome} showSixOrdinal={true}/>
                <div className="body mobile-body">
                    <div className={"row"}>
                        <div className={"col-8"}>
                            <div className={"d-flex"}>
                                {ticket.legs.map((run: any, legIndex: number) => (
                                    <div
                                        className={`run ${
                                            bulletin[selectedHippodrome._id]?.runsMap[ticket.race_id + legIndex]?.status === 0
                                                ? ""
                                                : "disabled"
                                        }`}
                                        key={`legIndex-${legIndex}`}
                                    >
                                        <div>
                                            {BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At"
                                                ? ticket.race_id + legIndex
                                                : legIndex + 1}
                                            .
                                            {BettingTypesMap[Number(ticket.bet_type)].columnLabel === "At" &&
                                                BettingTypesMap[Number(ticket.bet_type)].columnLabel}
                                        </div>
                                        {run.map((horse: any, horseIndex: number) => {
                                            let isWinner = false;

                                            try {
                                                isWinner = todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? Number(ticket.race_id) + legIndex : legIndex + 1]?.winnerHorse.no.toString() === horse.toString()
                                                if (BettingTypesMap[Number(ticket.bet_type)]?.isStablemateWins){
                                                    if (todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate){
                                                        for (const horseElement of todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate) {
                                                            isWinner = horseElement.no.toString() === horse.toString()
                                                        }
                                                    }
                                                }

                                            }catch (e) {
                                                console.error(e);
                                            }
                                            return <div className={`${isWinner ? 'text-danger fw-bold' : ''}`} key={`horseIndex-${horseIndex}`}>{horse}</div>
                                        })}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={"col-4 ps-0"}>
                            <div className="info">
                                <div>
                                    BAHİS: <b>{ticket.bet_count}</b>
                                    <br/>
                                    MİSLİ: <b>{ticket.multiply}</b>
                                </div>
                                <div>
                                    TUTAR:
                                    <br/> <b className={"fs-5"}>{ticket.amount}₺</b>
                                </div>
                            </div>
                            <div
                                className={`cursor-pointer`}
                            >
                                <button
                                    className={`btn btn-sm btn-six dropdown-toggle  w-100 fw-bold`}
                                    data-bs-toggle="dropdown"
                                    style={{color: "#FFFFFF", borderRadius: "0"}}
                                    aria-expanded="false"
                                >
                                    Hızlı Kupon
                                </button>
                                <RapidCouponMenu types={playableTicketTypes} onPick={(type: any) => playRapid(ticket, type.betType.id, type)}/>
                            </div>
                            <div
                                className={`status cursor-pointer`}
                                style={{borderTopLeftRadius: "0", borderTopRightRadius: "0"}}
                                onClick={() => {
                                    playTicket(ticket);
                                }}
                            >
                                OYNA
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer"></div>
            </div>
        </>
    );
}
